import { applicationAssetApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ASSETS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/assets`,
  {
    GET_ASSETS: 'GET_ASSETS',
    DELETE_ASSET: 'DELETE_ASSET',
  },
);

const assetsSchema = new schema.Entity('data', {}, { idAttribute: 'assetId' });

export const getLoanAssetsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationAssetApi.getAssets(params);

  return dispatch({
    type: ASSETS_ACTION_TYPE.GET_ASSETS,
    payload: normalize(data, [assetsSchema]).entities.data,
  });
});

export const deleteLoanAssetAction = params => async dispatch => {
  const { assetId } = params;

  const { data } = await applicationAssetApi.deleteAsset(params);

  return dispatch({
    type: ASSETS_ACTION_TYPE.DELETE_ASSET,
    payload: data,
    meta: { assetId },
  });
};
